module.exports = __webpack_public_path__ + "fonts/auc.19a4b27b.ttf";